import { cx } from 'emotion';
import {
  arrayOf, bool, func, node, number, object, oneOfType, shape, string,
} from 'prop-types';
import { isNil } from 'ramda';
import React, { isValidElement } from 'react';

import { isObject } from '@ezugi/utils';

import Icon from '../Icon/Icon';
import {
  Action, Li, Primary, Secondary, Text, Ul, Visual, itemWithDivider,
} from './style';

const List = (props) => {
  const {
    items = [],
    width,
    height,
    listClassName,
    itemClassName,
    listStyle,
    itemStyle,
    itemHeight,
    showDivider,
  } = props;
  return (
    <Ul
      style={{
        ...(width && { width }),
        ...(height && { height }),
        ...listStyle,
      }}
      className={listClassName}
      data-name="list"
    >
      {items.map(({ id, render, label, icon, subLabel, action, onActionClick, key, ...rest }, i) => (render || (
        <Li
          key={key || id || label}
          style={{
            ...(!isNil(itemHeight) && { height: itemHeight }),
            ...itemStyle,
          }}
          className={cx({ [itemWithDivider]: showDivider && i > 0 }, itemClassName)}
          data-name="listitem"
          {...rest}
        >
          <Visual>
            {isValidElement(icon)
              ? icon
              : icon && <Icon size={24} {...(isObject(icon) ? icon : { svg: icon })} />}
          </Visual>
          <Text>
            <Primary>
              {label}
            </Primary>
            {subLabel && (
              <Secondary>
                {subLabel}
              </Secondary>
            )}
          </Text>
          <Action
            {...{
              ...(action && {
                onClick: (e) => {
                  e.stopPropagation();
                  onActionClick();
                },
              }),
            }}
          >
            {isValidElement(action)
              ? action
              : action && <Icon size={24} {...(isObject(action) ? action : { svg: action })} />}
          </Action>
        </Li>
      )))}
    </Ul>
  );
};

const ItemType = shape({
  id: oneOfType([ string, number ]),
  icon: oneOfType([ string, object, node ]),
  action: oneOfType([ string, object, node ]),
  onActionClick: func,
  label: oneOfType([ string, node ]),
  subLabel: oneOfType([ string, node ]),
  onClick: func,
});

List.propTypes = {
  items: arrayOf(ItemType),
  width: string,
  height: string,
  listClassName: string,
  listStyle: object,
  itemClassName: string,
  itemStyle: object,
  itemHeight: string,
  showDivider: bool,
};

export default List;
